import styled from 'styled-components';
import { buttonBase, getButtonSize, getToggleButtonAppearance, stretchButton } from 'modules/buttonStyles';
export const ToggleButton = styled.button `
  ${buttonBase};
  ${stretchButton};

  ${(props) => getToggleButtonAppearance(props.appearance, props.$toggled)}
  ${(props) => getButtonSize(props.size)};
`;
